import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ApolloGqlTalentBoardStats } from '@bloomays-lib/types.shared';

export type TalentBoardStatsState = {
  statsByJobId: Record<string, ApolloGqlTalentBoardStats>;
  fetchedAtByJobId: Record<string, number>;
  setStats: (jobId: string, stats: ApolloGqlTalentBoardStats) => void;
  getStats: (jobId: string) => ApolloGqlTalentBoardStats | undefined;
  mustRefreshStats: (jobId: string) => boolean;
  reset: () => void;
};

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export const useTalentBoardStatsStore = create<TalentBoardStatsState>()(
  persist(
    (set, get) => ({
      statsByJobId: {},
      fetchedAtByJobId: {},

      setStats: (jobId: string, stats: ApolloGqlTalentBoardStats) =>
        set((state) => ({
          statsByJobId: { ...state.statsByJobId, [jobId]: stats },
          fetchedAtByJobId: { ...state.fetchedAtByJobId, [jobId]: Date.now() },
        })),

      getStats: (jobId: string) => {
        return get().statsByJobId[jobId];
      },

      mustRefreshStats: (jobId: string) => {
        const fetchedAt = get().fetchedAtByJobId[jobId] ?? null;
        if (fetchedAt === null) {
          return true;
        }
        const now = Date.now();
        return now - fetchedAt > CACHE_TTL_MS;
      },

      reset: () => set({ statsByJobId: {}, fetchedAtByJobId: {} }),
    }),
    {
      name: 'bloomays-talentboard-stats',
      partialize: (state) => ({
        statsByJobId: state.statsByJobId,
        fetchedAtByJobId: state.fetchedAtByJobId,
      }),
    },
  ),
);

export default useTalentBoardStatsStore;
